<template>
    <div class="items-center p-6">
        <div class="block md:flex">
            <div class="w-full md:w-1/2 md:pr-4 md:border-r md:border-gray-300 relative">
               <next-price-drop
                   :auction="auction"
                   :next-price-drop="nextPriceDrop"
                   @auctionDataUpdated="reloadData"
                   :current-live-show="currentLiveShow"
                   :next-live-show="nextLiveShow"/>
            </div>
            <div class="w-full md:w-1/2 md:pl-4 mt-8 md:mt-0">
                <div class="chart-inner-headline mb-4 h-16">{{$t('pages.controlpanel.index.controls.producer_control.stop_live_show.title')}}</div>
                <div class="items-center mt-3" v-if="!currentLiveShow && nextLiveShow">
                    {{$t('pages.controlpanel.index.controls.producer_control.stop_live_show.next_show')}}
                    <div class="block headline text-center mt-4">{{timeUntilNextLiveShow}}</div>
                </div>
                <div class="flex items-center ml-2 mt-3" v-if="!currentLiveShow && !nextLiveShow">
                    {{$t('pages.controlpanel.index.controls.producer_control.stop_live_show.no_show_running_and_no_left')}}
                </div>
                <div v-if="currentLiveShow">
                    <div class="">
                        <div
                            class="mt-3 text-xl"
                            v-if="!priceHasDropped"
                        >
                            {{$t('pages.controlpanel.index.controls.producer_control.stop_live_show.stop_after_drop')}}
                        </div>
                        <button
                            v-if="priceHasDropped"
                            @click="showStopLiveShowConfirmationDialog()"
                            type="button"
                            class="btn btn-danger ml-auto"
                        >
                            {{$t('pages.controlpanel.index.controls.producer_control.stop_live_show.button_label')}}
                        </button>
                        <div class="flex mt-5 items-center">
                            <span class="text-center mr-3 items-center">{{$t('pages.controlpanel.index.controls.producer_control.stop_live_show.ends_in')}}</span>
                            <span class="headline text-center">{{timeUntilLiveShowEnds}}</span>
                        </div>
                    </div>
                    <div class="ml-auto text-xs mt-5">
                        <span class="">{{$t('pages.controlpanel.index.controls.producer_control.stop_live_show.text')}}</span>
                    </div>
                </div>
                <div class="loading-indicator" v-if="sendingStopLiveShow">
                    <icon name="clock" class="w-8 h-8 mx-auto animate-spin"/>
                </div>
                <alert-message
                    v-if="showStopLiveShowFailed"
                    :error-type="ERROR_TYPE_ERROR"
                    :show-as-list="false"
                    :messages="[this.$t('pages.controlpanel.index.controls.producer_control.stop_live_show.stop_failed')]"
                    :display-errors-title="false"
                    @close="hideStopLiveShowFailedAlertClosed()"
                    class="sm:px-0 lg:px-0 pr-4 sm:pr-6 lg:pr-4"
                />
            </div>
        </div>
        <modal
            ref="stopLiveShowConfirmDialog"
            @confirm="onSubmitStopLiveShow"
            @cancel="onCancelStopLiveShow"
            :dangerous="true"
            :title="this.$t('pages.controlpanel.index.controls.producer_control.stop_live_show.confirm_stop.title')">
            <span class="">{{$t('pages.controlpanel.index.controls.producer_control.stop_live_show.confirm_stop.confirm')}}</span>
        </modal>
    </div>
</template>

<script>

import Icon from "../Icon";
import Modal from "../Modals/Modal";
import {ErrorTypes} from '../../mixins/ErrorTypes';
import AlertMessage from "@/Shared/Alerts/AlertMessage";
import NextPriceDrop from "./NextPriceDrop";
import CountDownService from "../../Services/CountDownService";
import moment from "moment/moment";
import TimeZoneService from "../../Services/TimeZoneService";

export default {
    components: {
        Icon,
        Modal,
        AlertMessage,
        NextPriceDrop
    },
    mixins:[
        ErrorTypes
    ],
    props: {
        auction: Object,
        nextLiveShow: Object,
        nextPriceDrop: Object,
        currentLiveShow: Object,
        timeNextLiveShow: String,
        timeLiveShowEnds: String
    },
    data() {
        return {
            sendingStopLiveShow: false,
            showStopLiveShowFailed: false,
            countDownUntilNextLiveShow: null,
            countDownUntilLiveShowEnds: null,
            timeUntilNextLiveShow: '',
            timeUntilLiveShowEnds: '',
            priceHasDropped: true
        }
    },
    computed: {
        tz() {
            return TimeZoneService;
        }
    },
    methods: {
        onSubmitStopLiveShow() {
            if(this.currentLiveShow && this.sendingStopLiveShow !== true) {
                this.sendingStopLiveShow = true;
                this.$refs.stopLiveShowConfirmDialog?.hide();
                this.showStopLiveShowFailed = false;

                axios.put(route('auctions.stopLiveShow', {auction:this.auction.id})) // Call the server and stop the live show
                    .catch((err) => {
                        this.showStopLiveShowFailed = true;
                        console.log(err);
                    })
                    .finally(() => {
                        this.sendingStopLiveShow = false;
                    });
            }
        },
        onCancelStopLiveShow() {
            this.$refs.stopLiveShowConfirmDialog?.hide();
        },
        showStopLiveShowConfirmationDialog() {
            this.$refs.stopLiveShowConfirmDialog?.show();
        },
        startTimerLiveShowWillEnd() {
            let that = this;
            this.updatePriceHasDropped();
            this.countDownUntilLiveShowEnds = setInterval(function () {
                let timer = (new Date(that.timeLiveShowEnds).valueOf() - Date.now()) / 1000;
                that.updatePriceHasDropped();
                that.timeUntilLiveShowEnds = CountDownService.formatTimer(Math.max(0, timer), that.$t('pages.controlpanel.index.controls.producer_control.stop_live_show.seconds')).join(':');
                if (timer <= 0) {
                    clearInterval(that.countDownUntilLiveShowEnds);
                    that.reloadData();
                }
            }, 1000);
        },
        startTimerNextLiveShowWillStart() {
            let that = this;
            this.updatePriceHasDropped();
            this.countDownUntilNextLiveShow = setInterval(function () {
                that.updatePriceHasDropped();
                let timer = (new Date(that.timeNextLiveShow).valueOf() - Date.now()) / 1000;
                that.timeUntilNextLiveShow = CountDownService.formatTimer(Math.max(0,timer), that.$t('pages.controlpanel.index.controls.producer_control.stop_live_show.seconds')).join(':');
                if (timer <= 0) {
                    clearInterval(that.countDownUntilNextLiveShow);
                    that.reloadData();
                }
            }, 1000);
        },
        hideStopLiveShowFailedAlertClosed() {
            this.showStopLiveShowFailed = false;
        },
        startTimers() {
            if(this.nextLiveShow && !this.currentLiveShow) {
                this.startTimerNextLiveShowWillStart();
            }
            if(this.currentLiveShow) {
                this.startTimerLiveShowWillEnd();
            }
        },
        clearTimers() {
            clearInterval(this.countDownUntilNextLiveShow);
            this.countDownUntilNextLiveShow = null
            clearInterval(this.countDownUntilLiveShowEnds);
            this.countDownUntilLiveShowEnds = null;
        },
        restartTimers() {
            this.clearTimers();
            this.startTimers();
        },
        reloadData() {
            this.$inertia.reload({
                only: [
                    'auction',
                    'currentLiveShow',
                    'nextLiveShow',
                    'nextPriceDrop',
                    'timeNextLiveShow',
                    'timeLiveShowEnds'
                ],
                onSuccess: data => {
                    this.restartTimers();
                }
            });
        },
        updatePriceHasDropped() {
            let liveShowStartTime = moment.tz(this.currentLiveShow?.date_start, this.tz.auctionTimeZone()).valueOf();
            let liveShowEndTime = moment.tz(this.currentLiveShow?.date_end, this.tz.auctionTimeZone()).valueOf();
            let priceDropTime = moment.tz(this.nextPriceDrop?.date_start, this.tz.auctionTimeZone()).valueOf();
            if (priceDropTime >= liveShowStartTime && priceDropTime <= liveShowEndTime) { // innerhalb der aktuellen Live show
                this.priceHasDropped = Date.now().valueOf() > priceDropTime || !this.nextPriceDrop;
            }
        }
    },
    watch: {
        nextLiveShow() {
            this.clearTimers();
            this.startTimers();
        },
        currentLiveShow() {
            this.clearTimers();
            this.startTimers();
        }
    },
    mounted() {
        this.clearTimers();
        this.startTimers();
    },
    beforeDestroy() {
        this.clearTimers();
    },
    created: function() {
        window.addEventListener('focus', this.reloadData);
    },
    destroyed: function() {
        window.removeEventListener('focus', this.reloadData);
    }
}
</script>
